import { Input as AntdInput }         from 'antd';
import { injectIntl }                 from 'react-intl';
import type { WrappedComponentProps } from 'react-intl';
import type { PasswordProps }         from 'antd/es/input';

interface InputPasswordProps extends PasswordProps, WrappedComponentProps {
  placeholder?: any;
}

const InputPassword = (props: InputPasswordProps) => {
  const allProps = {
    ...props,
  };

  if (props.placeholder) {
    allProps.placeholder = props.intl.formatMessage({
      id: props.placeholder || ' ',
    });
  }

  return <AntdInput.Password autoComplete="off" {...allProps} />;
};

export default injectIntl(InputPassword);
